import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, actions } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import Translation from "../../../../common/translation/translation.component"
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from '../../../../../utils/constant.utils';
import {
    ORFButton, ORFDatePicker
    , ORFSearchSuggestions as SearchSuggestions
    , OR_RRF_TextArea as TextArea, OR_RRF_Select as Select
} from '../../../../common/forms/order-request-form.component';
import { MAX_LENGTH, CIRCUIT_STATUS, SUBMIT_REQUEST_TITLE } from '../../../../../constants/external-constants';
import { wirelessIntlRoamingAccessActions } from "./../../../../../store/external/request-reducer/order-request-reducer/wireless-request/wireless-intl-roaming-access.reducer";
import { createRequestActions } from "./../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../store/external/request-reducer/request-log.reducer";
import DATEPICKER_OR from '../../../../common/custom-form/custom-date-picker.component';
import { withRouter } from 'react-router-dom';
import { ConfirmationNotificationModal } from "../../../../common/modal/confirmation-modal.component";
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import { convertToUtcDate, assignDefaultIfEmptyString } from '../../../../../utils/helpers.utils';


class IntlRoamingAccessForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
            , startDate: ''
            , endDate: ''
            , error: false
            , isSaving: false
            , RequestTypeId :''
        }
        this.SearchSuggestions = React.createRef();
    }
    async componentDidMount() {
        const { updateDataList, isUpdateRequest, subscriptionList, isRequestOnBehalf, takeActionCircuitCode, takeActionCircuitId } = this.props.createRequest;
        const { requestDetail, onUpdateAutoPopulate, fetchSubscriptionByValue, onSubscriptionSelect, onROBSubscripitionAutoSelect, getNewIntlRoamingAccessFormData} = this.props
        const orderId = this.props.match.params.orderId;
      
        this.props.fetchIntlOptions();
        if (takeActionCircuitId != null || takeActionCircuitId !== undefined) {
            var circuitCodePropName = 'CircuitCode';
            var subscriptionLists = await fetchSubscriptionByValue(takeActionCircuitCode, circuitCodePropName);

            onSubscriptionSelect(takeActionCircuitCode, circuitCodePropName, subscriptionLists, null, takeActionCircuitId);
        }
        else {
            onSubscriptionSelect('');
        }

        if (isUpdateRequest) {
            const selectedItem = requestDetail.requestData.Order;
            const currentCircuitCode = requestDetail.requestData.Circuit.CircuitCode;
            var circuitCodePropName = 'CircuitCode';
            if (selectedItem?.IsRequestedInBehalf) {
                this.SearchSuggestions.current.onChange(null, { newValue: currentCircuitCode })
                await onROBSubscripitionAutoSelect(currentCircuitCode, selectedItem.EndUserId)
                await getNewIntlRoamingAccessFormData(orderId);
            }
            else {
                await fetchSubscriptionByValue(currentCircuitCode).then(() => {
                    this.setState({ isLoading: false });
                });
                if (this.state.isLoading == false) {
                    await onSubscriptionSelect(currentCircuitCode, circuitCodePropName, subscriptionList)
                    await getNewIntlRoamingAccessFormData(orderId);
                    this.SearchSuggestions.current.onChange(null, { newValue: currentCircuitCode })
                }
            }
        }
    }


    componentWillUnmount() {
        this.props.resetWirelessIntlRoamingAccessForm();
        this.props.resetRequestData();
    }

    setStartDate = (v) => {
        this.setState({
            startDate: v
        });
    }

    setEndDate = (v) => {
        this.setState({
            endDate: v
        });
    }

    submitRequest = async () => {
        const { submitRequest, modalMessage, fetchRequestLogItems } = this.props;
        const { startDate, endDate } = this.state;

        this.setState({ showConModal: true })
    }
    handleConfirmationModal = async (buttonType) => {

        if (buttonType === CONFIRMATION_VALUE.Ok) {
            const { submitRequest, fetchRequestLogItems } = this.props;
            this.setState({
                isSaving: true,
            });
            var success = await submitRequest();
            if (success.Success) {
                fetchRequestLogItems(0);
                this.setState({
                    title: "Success",
                    isSaving: false
                })
                this.props.hideRequestModal();
            } else {
                this.setState({
                    title: "Error",
                    isSaving: false
                })
            }
            this.setState(prev => ({
                showConModal: !prev.showConModal,
                show: true,
                message: success.ok != false ? success.Message : 'Incorrect Data'
            }))
        } else {
            this.setState({
                showConModal: false
            });
        }
    }

    haveError = (value) => {
        this.setState({
            error: value
        })
    }

    handleCloseNotif = () => {
        this.setState({ show: false });
        if (this.state.title !== "Error") {
            this.props.history.goBack();
        }
    }
    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    };
        
    render() {           
        const { subscriptionList, takeActionCircuitCode, isUpdateRequest } = this.props.createRequest;
        const { wirelessIntlRoamingAccessForm, onSubscriptionSelect, fetchSubscriptionByValue } = this.props;
        const { requestData } = this.props.requestDetail;
        const { subscription, formSubmitted, isResetLoading,internationalRequestOptions } = this.props.wirelessIntlRoamingAccessRequest;
        var isUpdateDate = wirelessIntlRoamingAccessForm.startDate != '' || wirelessIntlRoamingAccessForm.endDate != '';
        var circuitStatusName = isUpdateRequest && subscriptionList.length ? subscriptionList[0].CircuitStatus : subscription.CircuitStatus != null && subscription.CircuitStatus != "" ? subscription.CircuitStatus : "";
        var initialRequest = !(wirelessIntlRoamingAccessForm.circuitId != 0 
            && wirelessIntlRoamingAccessForm.startDate 
            && internationalRequestOptions.find(x => x.Key == wirelessIntlRoamingAccessForm.RequestTypeId) !== undefined 
            && wirelessIntlRoamingAccessForm.endDate 
            && wirelessIntlRoamingAccessForm.businessJustification != '' 
            && !formSubmitted);
        var updateRequest = isUpdateRequest ?
            (wirelessIntlRoamingAccessForm.circuitId != 0 && (wirelessIntlRoamingAccessForm.startDate != '') && (wirelessIntlRoamingAccessForm.endDate != '') && wirelessIntlRoamingAccessForm.businessJustification != '' &&  !formSubmitted) &&
                (requestData.CircuitId != wirelessIntlRoamingAccessForm.circuitId 
                || requestData.Order.CountriesToBeVisited != wirelessIntlRoamingAccessForm.countriesToBeVisited
                || requestData.Order.RequestType.RequestTypeID != wirelessIntlRoamingAccessForm.RequestTypeId
                    || requestData.BusinessJustification.BusinessJustification != wirelessIntlRoamingAccessForm.businessJustification
                    || requestData.BusinessJustification.AdditionalInformation != assignDefaultIfEmptyString(wirelessIntlRoamingAccessForm.additionalInformation, null)
                    || convertToUtcDate(requestData.Order.StartDate, true, "DD MMM YYYY") != convertToUtcDate(wirelessIntlRoamingAccessForm.startDate, true, "DD MMM YYYY")
                    || convertToUtcDate(requestData.Order.EndDate, true, "DD MMM YYYY") != convertToUtcDate(wirelessIntlRoamingAccessForm.endDate, true, "DD MMM YYYY") ) ? false : true : false;
        let minDate = new Date();
        minDate.setDate(minDate.getDate() - 7);

        return (
            <div>
                <NotificationModal
                    show={this.state.show}
                    title={this.state.title}
                    message={this.state.message}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer modal-text-bold'}
                />
                <ConfirmationNotificationModal 
                    show={this.state.showConModal}
                    message={isUpdateRequest ? this.toLocaleLanguage("update_order_request_confirmation") : this.toLocaleLanguage("create_order_request_confirmation")}
                    title={isUpdateRequest ? SUBMIT_REQUEST_TITLE.updateRequest : this.toLocaleLanguage("submit_form_request_title")}
                    handleModal={this.handleConfirmationModal}
                    customClass={'comment-notification-modal modal-text-bold'}
                    disabled={this.state.isSaving}
                />
                <Form method="post" role="form"
                    model="wirelessIntlRoamingAccessForm"
                    onSubmit={this.submitRequest}
                >                 
                    <Row className='mh-70 '>
                        <Col xs={12} md={12} lg={12}>
                            {
                                !isResetLoading && <SearchSuggestions
                                    ref={this.SearchSuggestions}
                                    value={wirelessIntlRoamingAccessForm.circuitCode}
                                    label={`${this.toLocaleLanguage('mobile_phone_number')}`}
                                    requiredField
                                    propDisplay={'CircuitCode'}
                                    options={subscriptionList.length > 0 ? subscriptionList : ''}
                                    onChangeAction={onSubscriptionSelect}
                                    searchAction={fetchSubscriptionByValue}
                                    defaultValue={takeActionCircuitCode}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                    errorMessage={this.toLocaleLanguage('error_mobile_number_not_exist')}
                                    haveError={this.haveError}
                                />
                            }
                        </Col>
                        {wirelessIntlRoamingAccessForm.circuitCode !== '' &&
                            <div className="pb-15-pl-30">
                                <span className={circuitStatusName === CIRCUIT_STATUS.inService.name ? "status-inservice" : "status-suspended" }>{circuitStatusName} </span> <span>| </span>
                                {isUpdateRequest && subscriptionList.length ? subscriptionList[0].VendorName : subscription.VendorName != null && subscription.VendorName != "" ? subscription.VendorName : ""} <span>| </span>
                                {isUpdateRequest && subscriptionList.length ? (subscriptionList[0].PlanName != null && subscriptionList[0].PlanName != "" ? subscriptionList[0].PlanName : <Translation translationKey="no_plan_available" />) : subscription.PlanName != null && subscription.PlanName != "" ? subscription.PlanName : <Translation translationKey="no_plan_available" />} <span>| </span>
                                {isUpdateRequest && subscriptionList.length ? (subscriptionList[0].DeviceName != null && subscriptionList[0].DeviceName != "" ? subscriptionList[0].DeviceName : <Translation translationKey="no_device_available" /> ): subscription.DeviceName != null && subscription.DeviceName != '' ? subscription.DeviceName : <Translation translationKey="no_device_available" />}
                            </div>
                        }
                    </Row>             
                    <div className="text-field-title-container">
                        <span className='text-field-title'><Translation translationKey="intl_roaming_access_details" /></span>
                    </div>
                 <Row> 
                        <Col xs={12} md={12} lg={12} className='required'>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('Request')}`}
                                value={wirelessIntlRoamingAccessForm.RequestTypeId}
                                options={internationalRequestOptions}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.RequestTypeId'
                            />
                        </Col>
                
                        <Col xs={6} md={6} lg={6}>
                            <div className="date-picker-group">
                                <DATEPICKER_OR 
                                    label={`${this.toLocaleLanguage('intl_roam_acc_start_date')}`}
                                    subLabel={`${this.toLocaleLanguage('parenthesis_effectivity_date')}`}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    startDate={wirelessIntlRoamingAccessForm.startDate}
                                    selectedDate={(date) => this.props.FormChange("wirelessIntlRoamingAccessForm.startDate", date)} 
                                    requiredField={true}
                                    isDisable={wirelessIntlRoamingAccessForm.circuitId == 0}
                                    minDate={minDate}
                                    customClass="intl-roaming-date-picker"
                                />
                            </div>                      
                        </Col>

                        <Col xs={6} md={6} lg={6}>
                        <   div className="date-picker-group">
                                <DATEPICKER_OR 
                                    label={`${this.toLocaleLanguage('intl_roam_acc_end_date')}`}
                                    subLabel={`${this.toLocaleLanguage('parenthesis_effectivity_date')}`}
                                    placeholder={this.toLocaleLanguage('select_placeholder')}
                                    startDate={isUpdateDate ? (wirelessIntlRoamingAccessForm.startDate <= wirelessIntlRoamingAccessForm.endDate ? wirelessIntlRoamingAccessForm.endDate : null) : (wirelessIntlRoamingAccessForm.startDate <= wirelessIntlRoamingAccessForm.endDate ? wirelessIntlRoamingAccessForm.endDate : null)  } 
                                    selectedDate={(date) => this.props.FormChange("wirelessIntlRoamingAccessForm.endDate", date)} 
                                    requiredField={true}
                                    isDisable={wirelessIntlRoamingAccessForm.circuitId == 0}
                                    minDate={isUpdateDate ? (wirelessIntlRoamingAccessForm.startDate <= minDate ? minDate : wirelessIntlRoamingAccessForm.startDate) : (wirelessIntlRoamingAccessForm.startDate <= minDate ? minDate : wirelessIntlRoamingAccessForm.startDate)}
                                    customClass="intl-roaming-date-picker"
                                /> 
                            </div>                   
                        </Col>

                    </Row>
                       
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required'>
                            <TextArea
                                label={`${this.toLocaleLanguage('business_justification')}`}
                                fieldProp='.businessJustification'
                                value={wirelessIntlRoamingAccessForm.businessJustification}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                maxLength={MAX_LENGTH.limit_500}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea
                                label={`${this.toLocaleLanguage('country')}`}
                                fieldProp='.countriesToBeVisited'
                                value={wirelessIntlRoamingAccessForm.countriesToBeVisited}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                maxLength={MAX_LENGTH.limit_100}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <TextArea
                                label={this.toLocaleLanguage('additional_information')}
                                fieldProp='.additionalInformation'
                                value={wirelessIntlRoamingAccessForm.additionalInformation}
                                placeholder={this.toLocaleLanguage('enter_text_placeholder')}
                                maxLength={MAX_LENGTH.limit_1000}
                            />
                        </Col>
                    </Row>
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={this.onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={this.toLocaleLanguage('submit_request_button')}
                                    variant={"primary"}
                                    type="submit"
                                    disabled={isUpdateRequest ? updateRequest : initialRequest}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default withRouter(
    connect(
        state => {
            const { createRequest, wirelessIntlRoamingAccessRequest, translation, requestDetail } = state;
            const { wirelessIntlRoamingAccessForm } = state.form;
            return {
                wirelessIntlRoamingAccessForm
                , createRequest
                , requestDetail
                , wirelessIntlRoamingAccessRequest
                , ...translation,
            };
        }
        , dispatch => ({
            ...bindActionCreators(
                Object.assign({}, wirelessIntlRoamingAccessActions
                    , createRequestActions
                    , requestLogActions),
                dispatch
                ),
                FormChange: (Model, value) => {
                    dispatch(actions.change(Model, value))
                }
         })
)(IntlRoamingAccessForm));